import React from 'react';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import {
  Box,
  Button,
  Popover,
  Typography,
  Badge,
  IconButton,
  Stack,
} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Chip from '@mui/material/Chip';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';

const NotiBox = ({ noties, notiCount, onConfirmNoties,onConfirmNotiAll, onRefresh }) => {
  return (
    <PopupState variant="popover" popupId="NotiPopover">
      {(popupState) => (
        <Box>
          <IconButton color="inherit" {...bindTrigger(popupState)}>
            <Badge badgeContent={notiCount} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>

          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                //maxWidth: 380,
                minWidth: 600,
                maxHeight: 400,
                overflowY: 'auto',
              }}
            >
              <List sx={{ width: '100%', minWidth: 600 }}>
                {noties.length === 0 && (
                  <ListItem alignItems="center">
                    확인할 알림이 없습니다
                  </ListItem>
                )}

                {noties.length > 0 &&
                  noties.map((noti, index) => {
                    return (
                      <React.Fragment key={index}>
                        <ListItem dense divider>
                          <ListItemButton>
                            <ListItemText
                              secondary={
                                <React.Fragment>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'flex-start',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {noti.viewYn === 'N' && (
                                      <Badge
                                        badgeContent={noti.viewYn}
                                        size="small"
                                        sx={{ mx: 1 }}
                                        color="error"
                                      />
                                    )}
                                    <Chip
                                      label={
                                        noti.notiTyp === 'TECH'
                                          ? `기술`
                                          : `영업`
                                      }
                                      size="small"
                                      sx={{ mx: 1 }}
                                      color={
                                        noti.notiTyp === 'TECH'
                                          ? `info`
                                          : `warning`
                                      }
                                    />

                                    {/* <Link
                                    // underline="none"
                                    variant="body2"
                                    color="inherit"
                                    component={RouterLink}
                                    to={noti.notiUrl}
                                  >
                                    {noti.notiTxt}
                                    {noti.viewYn}
                                  </Link> */}
                                    <Typography
                                      component="div"
                                      variant="body2"
                                      align="left"
                                      onClick={() => onConfirmNoties(noti)}
                                    >
                                      {noti.notiTxt}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Typography
                                      component="div"
                                      variant="body2"
                                      color="text.disabled"
                                      align="left"
                                    >
                                      {noti.crtDt}
                                    </Typography>
                                  </Box>
                                </React.Fragment>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      </React.Fragment>
                    );
                  })}
              </List>
            </Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ p: 1 }}
            >
              <Button
                color="primary"
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={onRefresh}
              >
                Refresh
              </Button>
              <Button
                color="inherit"
                variant="contained"
                startIcon={<CloseIcon />}
                onClick={onConfirmNotiAll}
              >
                전체 삭제
              </Button>
              <Button
                color="inherit"
                variant="contained"
                startIcon={<CloseIcon />}
                onClick={popupState.close}
              >
                닫기
              </Button>
            </Stack>
          </Popover>
        </Box>
      )}
    </PopupState>
  );
};

export default NotiBox;
